
























































import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TeishutsuStatusTable from '@/components/shounin/organisms/TeishutsuStatusTable.vue'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import Getsudo from '@/tcw/domain/Getsudo'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    TeishutsuStatusTable
  }
})
export default class TeishutsuStatusPage extends Mixins(BasePage) {

  // 現在の年月かどうかを判定する
  get isCurrentMonth(): boolean {
    return Getsudo.last(this.shimebi).isSameMonth(this.targetGetsudo, this.shimebi)
  }

  // 次月押下時のリンク作成
  private nextMonthLink() {
    this.calcMonthLink(1)
  }

  // 前月押下時のリンク作成
  private lastMonthLink() {
    this.calcMonthLink(0)
  }

  // 前月、次月ボタン押下時の処理
  private calcMonthLink(id: number) {
    const year = parseInt(this.routeParams.year)
    const month = parseInt(this.routeParams.month)
    let linkPath = '/teishutsu/member/status/'
    if (!isNaN(year) && !isNaN(month)) {
      // Dateオブジェクトを作成し、月を加算する
      const date = new Date(year, month - 1) // 月は0-indexedなので-1する
      if (id == 1) {
        // 次月の場合
        date.setMonth(date.getMonth() + 1)
      } else {
        // 前月の場合
        date.setMonth(date.getMonth() - 1)
      }
      // 年と月を取得してフォーマットする
      const calcYear = date.getFullYear()
      const calcMonth = date.getMonth() + 1 // 月は0-indexedなので+1する
      linkPath += calcYear + '/' + calcMonth
    } else {
      // 無効な年月の場合
      linkPath += this.routeParams
    }
    this.$router.push(linkPath)
    this.applyTable()
  }

  // カレンダー変更時のアクション
  private handleDateChange(value: Date | string): void {
    console.log('handleDateChange')
    console.log(typeof value)
    if (typeof value === 'string') {
      // value が文字列の場合、Date オブジェクトに変換する
      value = new Date(value)
    }
    const year = value.getFullYear()
    const month = value.getMonth() + 1 // 月は0-indexedなので+1する
    const linkPath = `/teishutsu/member/status/${year}/${month}`
    this.$router.push(linkPath)
    this.applyTable()
  }

  //  現在月に戻るボタン押下時のアクション
  private changeCurrentGetsudo() {
    const linkPath = `/teishutsu/member/status/${Getsudo.last(this.shimebi)}`
    this.$router.push(linkPath)
    this.applyTable()
  }

  get targetGetsudo(): Getsudo {
    if (this.routeParams.year && this.routeParams.month) {
      // URLパラメータに月度が指定されていた場合(承認対象者の提出情報を確認する場合)
      return Getsudo.of(this.routeParams.year, this.routeParams.month)
    } else {
      // 月度未指定の場合
      return Getsudo.now(this.shimebi)
    }
  }

  private applyTable(): void {
    const statusTableElem = (this.$refs.table as unknown) as { init: () => Promise<void> }
    if (statusTableElem?.init) {
      statusTableElem.init()
    }
  }

  private bulkExport(): void {
    const statusTableElem = (this.$refs.table as unknown) as { bulkExport: () => Promise<void> }
    if (statusTableElem?.bulkExport) {
      statusTableElem.bulkExport()
    }
  }
}
